import {put, takeLatest} from 'redux-saga/effects';
import {LOCALE_FETCH_LOCALISATIONS} from './constants';
import {appLoadInitValues} from '../app/actions';

export function* fetchLocalisationsSaga() {
	yield takeLatest(LOCALE_FETCH_LOCALISATIONS, function* () {
		yield put(appLoadInitValues());
	});
}
